import { colorsV4 } from "@tokenterminal/ui/theme/themeV4/colorsContract.css"
import { fetchAtom } from "data/api/useFetch"
import { useAtomValue } from "jotai"
import { useMemo } from "react"
import { Sparklines, SparklinesLine } from "react-sparklines"

function getFetchUrl({
  metric,
  projectSlugs,
}: {
  metric: string
  projectSlugs: string[]
}) {
  const search = new URLSearchParams([
    ["project_slugs", Array.from(new Set(projectSlugs)).join(",")],
    ["interval", "30d"],
  ])

  return `/v3/internal/charts/metrics/${metric}?${search}` as "/v3/internal/charts/metrics/:slug"
}

export const MiniChartSparkline = ({
  value,
  projectSlug,
  metric,
  height,
}: {
  value: number
  height: number
  projectSlug: string
  metric: string
}) => {
  const metricAtom = useMemo(
    () => fetchAtom(getFetchUrl({ metric, projectSlugs: [projectSlug] })),
    [metric, projectSlug]
  )
  const metricValues = useAtomValue(metricAtom)
  if (typeof value !== "number" || value === 0) return null

  // reverse the data
  const reversedData =
    metricValues?.ok?.data.map((d) => d.value).reverse() ?? []

  return (
    <div className="flex gap-2 items-center justify-between w-full">
      <Sparklines data={reversedData} svgHeight={height} margin={10}>
        <SparklinesLine
          color={value > 0 ? colorsV4.scale.emerald500 : colorsV4.scale.red500}
        />
      </Sparklines>
    </div>
  )
}

export const MiniChartInlineSparkline = ({
  value,
  height,
}: {
  value: number[]
  height: number
}) => {
  const data = useMemo(() => {
    return (value ?? []).toReversed()
  }, [value])

  if (value?.length === 0) return null

  const isPositive = data[0] < data[data.length - 1]

  return (
    <div className="relative w-full flex justify-end items-end">
      <Sparklines data={data} svgHeight={height} margin={10}>
        <SparklinesLine
          color={isPositive ? colorsV4.scale.emerald500 : colorsV4.scale.red500}
        />
      </Sparklines>
    </div>
  )
}
